import { connect } from "react-redux";
import {
  deleteCalcul,
  duplicateCalcul,
  sendXmlToEDEC,
  changeCalculsSort,
  setCalculArchived,
  updateCalculAttributes,
} from "../actions";
import {
  generateReports,
  getFdesMetaDataForCalculRow,
} from "../../fdes/actions";
import CalculsTable from "../components/CalculsTable";
import { createFolder } from "../../folders/actions";

export default connect(
  (state) => ({
    user: state.user.informations,
    calculs: state.calculs.calculs,
    calculsSort: state.calculs.sort,
    isGeneratingReports: state.loader.isGeneratingReports,
    generatingReportsIds: state.loader.generatingReportsIds,
    aggregatedFamilyProducts: state.familyProduct.aggregatedFamilyProducts,
    localEDECIntegration: state.configurator.localEDECIntegration,
    folders: state.folders.folders,
    tableScrollDisabled: state.loader.tableScrollDisabled,
    calculsColumns: state.user.informations.calculsColumns,
  }),
  (dispatch) => ({
    changeCalculsSort: (sort) => {
      dispatch(changeCalculsSort(sort));
    },
    generateReports: (filesToGenerate, userFdesId) => {
      dispatch(generateReports(filesToGenerate, userFdesId));
    },
    deleteCalcul: (calculId) => {
      dispatch(deleteCalcul(calculId));
    },
    duplicateCalcul: (calculId) => {
      dispatch(duplicateCalcul(calculId));
    },
    getFdesMetadataCalculRow: (fdesId) => {
      return new Promise((resolve, reject) => {
        dispatch(getFdesMetaDataForCalculRow(fdesId, resolve, reject));
      });
    },
    sendXmlToEDEC: (values) => {
      dispatch(sendXmlToEDEC(values));
    },
    createFolder: (folderDatas) => {
      dispatch(createFolder(folderDatas));
    },
    setCalculArchived: (calculId) => {
      dispatch(setCalculArchived(calculId));
    },
    updateCalculAttributes: (calculId, attributes) => {
      dispatch(updateCalculAttributes(calculId, attributes));
    },
  }),
)(CalculsTable);
